export const weather_types = {
  'CL': '-',
  'FW': '-',
  'SC': '-',
  'BK': '-',
  'OV': '-',
  'A':	'Hail',
  'BD': 'Blowing dust',
  'BN': 'Blowing sand',
  'BR': 'Mist',
  'BS': 'Blowing snow',
  'BY': 'Blowing spray',
  'F': 'Fog',
  'FR': 'Frost',
  'H': 'Haze',
  'IC': 'Ice crystals',
  'IF': 'Ice fog',
  'IP': 'Sleet',
  'K': 'Smoke',
  'L': 'Drizzle',
  'R': 'Rain',
  'RW': 'Rain showers',
  'RS': 'Rain/snow mix',
  'SI': 'Snow/sleet mix',
  'WM': 'Wintry mix',
  'S': 'Snow',
  'SW': 'Snow showers',
  'T': 'Thunderstorms',
  'UP': 'Unknown precipitation',
  'VA': 'Volcanic ash',
  'WP': 'Waterspouts',
  'ZF': 'Freezing fog',
  'ZL': 'Freezing drizzle',
  'ZR': 'Freezing rain',
  'ZY': 'Freezing spray',
}
